import { useState } from 'react'
import type SwiperCore from 'swiper'
import { Carousel } from '#app/shared/ui/data-display/carousel/Carousel.js'

type Props = {
  slides: React.ReactNode[]
}
export const PopularCategoriesCarousel = ({ slides }: Props) => {
  const [swiper, setSwiper] = useState<SwiperCore | undefined>(undefined)
  const [currentSliderIndex, setCurrentSliderIndex] = useState(0)

  return (
    <Carousel
      slides={slides}
      className="w-full"
      slidesPerView={2.1}
      breakpoints={{
        320: {
          slidesPerView: 1.7,
          spaceBetween: 0,
        },
        360: {
          slidesPerView: 1.8,
          spaceBetween: 0,
        },
        390: {
          slidesPerView: 2.3,
          spaceBetween: 0,
        },
        420: {
          slidesPerView: 2.5,
          spaceBetween: 0,
        },
        500: {
          slidesPerView: 2.8,
          spaceBetween: 0,
        },
        550: {
          slidesPerView: 3.2,
          spaceBetween: 0,
        },
        628: {
          slidesPerView: 3.6,
          spaceBetween: 0,
        },
        639: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 4.4,
          spaceBetween: 16,
        },
        850: {
          slidesPerView: 4.6,
          spaceBetween: 16,
        },
        928: {
          slidesPerView: 5.1,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 5.4,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 5.8,
          spaceBetween: 16,
        },
        1080: {
          slidesPerView: 6.2,
          spaceBetween: 16,
        },
        1124: {
          slidesPerView: 6.5,
          spaceBetween: 16,
        },
        1180: {
          slidesPerView: 6.8,
          spaceBetween: 16,
        },
        1250: {
          slidesPerView: 7,
          spaceBetween: 16,
        },
      }}
      loop={true}
      swiper={swiper}
      setSwiper={setSwiper}
      activeIndex={currentSliderIndex}
      onActiveIndexChange={setCurrentSliderIndex}
    />
  )
}
